import { defineMessages } from 'react-intl';

import globalMessages from '../../utils/globalMessages';

const messages = defineMessages({
    ...globalMessages,

    title: {
        id: 'parameters.title',
        defaultMessage: 'Collections',
    },

    titleParameter: {
        id: 'parameters.titleParameter',
        defaultMessage: 'Parâmetro {entity}',
    },

    btnNewInvoice: {
        id: 'parameters.btnNewInvoice',
        defaultMessage: 'Nova Nota Fiscal',
    },

    registrationInfo: {
        id: 'parameters.registrationInfo',
        defaultMessage: 'Informações Parâmetro',
    },

    name: {
        id: 'global.name',
        defaultMessage: 'Nome',
    },

    cnpj: {
        id: 'global.cnpj',
        defaultMessage: 'CPF/CNPJ',
    },

    email: {
        id: 'global.email',
        defaultMessage: 'E-mail',
    },

    city: {
        id: 'global.city',
        defaultMessage: 'Cidade',
    },

    state: {
        id: 'global.state',
        defaultMessage: 'Estado',
    },

    home: {
        id: 'home.title',
        defaultMessage: 'Início',
    },
});

export default messages;
